<template>
  <div>
    <div @click="goDingyue">立即订阅</div>
    <div class="dingyue_box" ref="dingyue_box_ref">
      立即订阅内容
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    // 锚点定位
    goDingyue() {
      // document
      //   .getElementById("agentTitle")
      //   .scrollIntoView({ block: "start", behavior: "smooth" });
      // 跳转到指定位置并且平滑滚动
      this.$el
        .querySelector(".dingyue_box")
        .scrollIntoView({ block: "center", behavior: "smooth" });
    },
  },
};
</script>
<style lang="less" scoped>
.dingyue_box {
  width: 300px;
  height: 400px;
  border: 2px solid #ccc;
}
</style>
